import axios from 'axios';

//const API_URL = 'http://localhost:8000';
const API_URL = 'https://api.antifurt.app';

// Configurare axios cu token
const axiosWithAuth = () => {
  const token = localStorage.getItem('token');
  return axios.create({
    baseURL: API_URL,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : '',
    },
  });
};

// Funcții pentru autentificare
export const login = async (email, password) => {
  const formData = new FormData();
  formData.append('username', email);
  formData.append('password', password);
  
  const response = await axios.post(`${API_URL}/token`, formData);
  return response.data;
};

export const register = async (email, password) => {
  const response = await axios.post(`${API_URL}/users/`, { email, password });
  return response.data;
};

export const getUserProfile = async () => {
  const api = axiosWithAuth();
  const response = await api.get(`${API_URL}/users/me/`);
  return response.data;
};

// Funcții pentru obiecte

// Reparat - Verifică dacă există token de autentificare pentru a asocia obiectele cu contul
export const createObject = async (objectData) => {
  // Verifică dacă utilizatorul este autentificat
  const token = localStorage.getItem('token');
  
  if (token) {
    // Dacă este autentificat, folosește token-ul pentru a asocia obiectul cu contul
    const api = axiosWithAuth();
    const response = await api.post(`${API_URL}/objects/`, objectData);
    return response.data;
  } else {
    // Dacă nu este autentificat, creează obiectul fără asociere cu un cont
    const response = await axios.post(`${API_URL}/objects/`, objectData);
    return response.data;
  }
};

export const getObject = async (objectId) => {
  const response = await axios.get(`${API_URL}/objects/${objectId}`);
  return response.data;
};

export const getObjectPublicStatus = async (objectId) => {
  const response = await axios.get(`${API_URL}/objects/${objectId}/status`);
  return response.data;
};

export const updateObject = async (objectId, updateData) => {
  const api = axiosWithAuth();
  const response = await api.put(`${API_URL}/objects/${objectId}`, updateData);
  return response.data;
};

export const updateObjectBySeed = async (seed, updateData) => {
  const data = { seed, ...updateData };
  const response = await axios.put(`${API_URL}/objects/by-seed`, data);
  return response.data;
};

export const verifySeed = async (seed) => {
  const response = await axios.post(`${API_URL}/objects/verify-seed`, { seed });
  return response.data;
};

export const getUserObjects = async () => {
  const api = axiosWithAuth();
  const response = await api.get(`${API_URL}/users/me/objects`);
  return response.data;
};

export const claimObject = async (seed) => {
  const api = axiosWithAuth();
  const response = await api.post(`${API_URL}/objects/claim`, { seed });
  return response.data;
};

export const deleteObject = async (objectId) => {
  const api = axiosWithAuth();
  const response = await api.delete(`${API_URL}/objects/${objectId}`);
  return response.data;
};

// Funcție pentru trimiterea locației la scanare
export const logObjectLocation = async (objectId, locationData) => {
  try {
    // Nu folosim autentificare pentru această cerere, deoarece poate fi accesată public
    const response = await axios.post(`${API_URL}/objects/${objectId}/location`, locationData);
    return response.data;
  } catch (error) {
    console.error("Eroare la trimiterea locației:", error);
    // Nu aruncăm eroarea pentru a nu întrerupe experiența utilizatorului
    return { error: "Nu s-a putut trimite locația" };
  }
};

// Funcție pentru obținerea istoricului locațiilor (necesită autentificare)
export const getObjectLocations = async (objectId) => {
  try {
    const api = axiosWithAuth();
    const response = await api.get(`${API_URL}/objects/${objectId}/locations`);
    return response.data;
  } catch (error) {
    console.error("Eroare la obținerea istoricului locațiilor:", error);
    throw error;
  }
};